/* eslint-disable prettier/prettier */
import { createSlice } from "@reduxjs/toolkit";
import { map } from "lodash";

export const catalogosSlice = createSlice({
  name: "catalogos",
  initialState: {
    hospitales: [],
    parentescos: [],
    serMedicos: [],
    estudiosMedicos: [],
    correos: [],
    medicos: [],
    isloadingHospitales: false,
    isloadingParentescos: false,
    isloadingSerMedicos: false,
    isloadingestudiosMedicos: false,
    isloadingcorreos: false,
    isloadingMedicos: false,
    alert: {
      type: "",
      message: "",
      show: false,
    },
  },
  reducers: {
    setData: (state, action) => {
      if (action.payload.type === "CAT_HOSPITAL") {
        state.hospitales = map(action.payload.data, (item) => {
          return { ...item, edit: false, longitud: 100 };
        });
      }
      if (action.payload.type === "CAT_PARENTESCOS") {
        state.parentescos = map(action.payload.data, (item) => {
          return { ...item, edit: false, longitud: 50 };
        });
      }
      if (action.payload.type === "CAT_SER_MEDICOS") {
        state.serMedicos = map(action.payload.data, (item) => {
          return { ...item, edit: false, longitud: 45 };
        });
      }
      if (action.payload.type === "CAT_ESTUDIOS") {
        state.estudiosMedicos = map(action.payload.data, (item) => {
          return { ...item, edit: false, longitud: 45 };
        });
      }
      if (action.payload.type === "CAT_CORREOS") {
        state.correos = map(action.payload.data, (item) => {
          return { ...item, edit: false, longitud: 255 };
        });
      }
      if (action.payload.type === "CAT_MEDICOS") {
        state.medicos = map(action.payload.data, (item) => {
          return { ...item, edit: false, longitud: 255 };
        });
      }
    },
    isLoading: (state, action) => {
      if (action.payload.type === "CAT_HOSPITAL") {
        state.isloadingHospitales = action.payload.data;
      }
      if (action.payload.type === "CAT_PARENTESCOS") {
        state.isloadingParentescos = action.payload.data;
      }
      if (action.payload.type === "CAT_SER_MEDICOS") {
        state.isloadingSerMedicos = action.payload.data;
      }
      if (action.payload.type === "CAT_ESTUDIOS") {
        state.isloadingestudiosMedicos = action.payload.data;
      }
      if (action.payload.type === "CAT_CORREOS") {
        state.isloadingcorreos = action.payload.data;
      }
      if (action.payload.type === "CAT_MEDICOS") {
        state.isloadingMedicos = action.payload.data;
      }
    },
    updateCheckCat: (state, action) => {
      if (action.payload.type === "CAT_HOSPITAL") {
        state.hospitales = map(state.hospitales, (item) => {
          if (item.idHospital === action.payload.data.idHospital) {
            return { ...item, activo: !action.payload.data.activo };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_PARENTESCOS") {
        state.parentescos = map(state.parentescos, (item) => {
          if (item.idParentescoCandidato === action.payload.data.idParentescoCandidato) {
            return { ...item, activo: !action.payload.data.activo };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_SER_MEDICOS") {
        state.serMedicos = map(state.serMedicos, (item) => {
          if (item.idServicioMedico === action.payload.data.idServicioMedico) {
            return { ...item, activo: !action.payload.data.activo };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_ESTUDIOS") {
        state.estudiosMedicos = map(state.estudiosMedicos, (item) => {
          if (item.idEstudio === action.payload.data.idEstudio) {
            return { ...item, activo: !action.payload.data.activo };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_CORREOS") {
        state.correos = map(state.correos, (item) => {
          if (item.id === action.payload.data.id) {
            return { ...item, activo: !action.payload.data.activo };
          }
          return item;
        });
      }
    },
    updateEdit: (state, action) => {
      if (action.payload.type === "CAT_HOSPITAL") {
        state.hospitales = map(state.hospitales, (item) => {
          if (item.idHospital === action.payload.data.idHospital) {
            return { ...item, edit: !action.payload.data.edit };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_PARENTESCOS") {
        state.parentescos = map(state.parentescos, (item) => {
          if (item.idParentescoCandidato === action.payload.data.idParentescoCandidato) {
            return { ...item, edit: !action.payload.data.edit };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_SER_MEDICOS") {
        state.serMedicos = map(state.serMedicos, (item) => {
          if (item.idServicioMedico === action.payload.data.idServicioMedico) {
            return { ...item, edit: !action.payload.data.edit };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_ESTUDIOS") {
        state.estudiosMedicos = map(state.estudiosMedicos, (item) => {
          if (item.idEstudio === action.payload.data.idEstudio) {
            return { ...item, edit: !action.payload.data.edit };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_CORREOS") {
        state.correos = map(state.correos, (item) => {
          if (item.id === action.payload.data.id) {
            return { ...item, edit: !action.payload.data.edit };
          }
          return item;
        });
      }
    },
    updateEditText: (state, action) => {
      if (action.payload.type === "CAT_HOSPITAL") {
        state.hospitales = map(state.hospitales, (item) => {
          if (item.idHospital === action.payload.data.idHospital) {
            return { ...item, hospital: action.payload.nuevoValor };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_PARENTESCOS") {
        state.parentescos = map(state.parentescos, (item) => {
          if (item.idParentescoCandidato === action.payload.data.idParentescoCandidato) {
            return { ...item, descripcion: action.payload.nuevoValor };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_SER_MEDICOS") {
        state.serMedicos = map(state.serMedicos, (item) => {
          if (item.idServicioMedico === action.payload.data.idServicioMedico) {
            return { ...item, descripcion: action.payload.nuevoValor };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_ESTUDIOS") {
        state.estudiosMedicos = map(state.estudiosMedicos, (item) => {
          if (item.idEstudio === action.payload.data.idEstudio) {
            return { ...item, descripcion: action.payload.nuevoValor };
          }
          return item;
        });
      }
      if (action.payload.type === "CAT_CORREOS") {
        state.correos = map(state.correos, (item) => {
          if (item.id === action.payload.data.id) {
            return { ...item, descripcion: action.payload.nuevoValor };
          }
          return item;
        });
      }
    },
    insertCatalogo: (state, action) => {
      if (action.payload.type === "CAT_HOSPITAL") {
        state.hospitales.unshift({ ...action.payload.data, edit: false, longitud: 100 });
      }
      if (action.payload.type === "CAT_PARENTESCOS") {
        state.parentescos.unshift({ ...action.payload.data, edit: false, longitud: 50 });
      }
      if (action.payload.type === "CAT_SER_MEDICOS") {
        state.serMedicos.unshift({ ...action.payload.data, edit: false, longitud: 45 });
      }
      if (action.payload.type === "CAT_ESTUDIOS") {
        state.estudiosMedicos.unshift({ ...action.payload.data, edit: false, longitud: 45 });
      }
      if (action.payload.type === "CAT_CORREOS") {
        state.correos.unshift({ ...action.payload.data, edit: false, longitud: 255 });
      }
    },
    UpdateItem: (state, action) => {
      if (action.payload.type === "CAT_HOSPITAL") {
        state.hospitales = state.hospitales.map((item) => {
          if (item.idHospital === action.payload.data.idHospital) return { ...item, edit: false };
          return item;
        });
      }
      if (action.payload.type === "CAT_PARENTESCOS") {
        state.parentescos = state.parentescos.map((item) => {
          if (item.idParentescoCandidato === action.payload.data.idParentescoCandidato)
            return { ...item, edit: false };
          return item;
        });
      }
      if (action.payload.type === "CAT_SER_MEDICOS") {
        state.serMedicos = state.serMedicos.map((item) => {
          if (item.idServicioMedico === action.payload.data.idServicioMedico)
            return { ...item, edit: false };
          return item;
        });
      }
      if (action.payload.type === "CAT_ESTUDIOS") {
        state.estudiosMedicos = state.estudiosMedicos.map((item) => {
          if (item.idEstudio === action.payload.data.idEstudio) return { ...item, edit: false };
          return item;
        });
      }
      if (action.payload.type === "CAT_CORREOS") {
        state.correos = state.correos.map((item) => {
          if (item.id === action.payload.data.id) return { ...item, edit: false };
          return item;
        });
      }
    },
    setUserAdd: (state, action) => {
      state.alert.type = "success";
      state.alert.message = "Registro de usuario exitoso";
      state.alert.show = true;
    },
    setUserError: (state, action) => {
      state.alert.type = "error";
      state.alert.message = action.payload;
      state.alert.show = true;
    },
    closeAlert: (state, action) => {
      state.alert.type = "";
      state.alert.message = "";
      state.alert.show = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setData,
  setUserAdd,
  isLoading,
  setUserError,
  closeAlert,
  updateCheckCat,
  updateEdit,
  updateEditText,
  insertCatalogo,
  UpdateItem,
} = catalogosSlice.actions;

export default catalogosSlice.reducer;
